var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Ort__Icn/40px/Legende/Ort",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Ort__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Ort__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,11 C24.9705627,11 29,15.0294373 29,20 C29,24.9705627 24.9705627,29 20,29 C15.0294373,29 11,24.9705627 11,20 C11,15.0294373 15.0294373,11 20,11 Z M20,13 C16.1340068,13 13,16.1340068 13,20 C13,23.8659932 16.1340068,27 20,27 C23.8659932,27 27,23.8659932 27,20 C27,16.1340068 23.8659932,13 20,13 Z M20,16 C22.209139,16 24,17.790861 24,20 C24,22.209139 22.209139,24 20,24 C17.790861,24 16,22.209139 16,20 C16,17.790861 17.790861,16 20,16 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Ort__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrt);
export default __webpack_public_path__ + "static/media/Ort.4d9bf65467a1562a871c5465cd63fd7d.svg";
export { ForwardRef as ReactComponent };